import Button from '@/components/NextUI/Button';
import Image from 'next/image';
import React from 'react';

const Try7DaysOk = () => {
  return (
    <div className="w-full h-dvh flex flex-col items-center justify-center">
      <div className="flex px-5 justify-center items-start">
        <div className="flex flex-col items-center w-full max-w-[424px]">
          <h2 className="text-dark text-[32px] md:text-[40px] font-semibold">
            Your Trial Starts Now!
          </h2>
          <Image
            src={'/images/try-7days-ok/banner.svg'}
            width={298}
            height={260}
            alt="try 7 days ok"
            className="mt-[32px]"
          />
          <p className="text-gray-medium text-[17px] md:text-lg mt-[32px]  text-center">
            You’ve unlocked powers to conquer documents. Compress, convert,
            edit, and sign anything with ease.
          </p>

          <Button className="w-[160px] md:w-full mt-[32px]" href="/profile">
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Try7DaysOk;
